import React, { props } from "react";
import scrm from "./images/scrm.svg";
import { Link } from "react-router-dom";
import "./App.css";
import BPLAM from "./images/formulationsss.svg";
import Quaimg from "./images/Qualisght.jpg";
import Optiimg from "./images/Optimus.jpg";
import retail from './images/retail.jpg';
import BATON from './images/Baton.jpg';
import FORESIGHT from './images/Project-Planning.jpg';
import LSReg from './images/LS-REG.jpg';
import Marketing from './images/Marketing.jpg';
import StrideTDOG from './images/Logistics-Risk-Assessment-Tool.jpg';
import SCOPE from './images/Sales-Continuity-and-Optimization-for-Proactive-Engagement.jpg';
import SupplierRiskEvaluation from './images/supplier-risk.jpg';

const isMainScreen = true;
const App = (props) => {
  // Energy.js

  // Other code for Energy.js

  return (
    <div className="energy-m">
      <div className="sub-H">
        <div className="head1">Home</div>
        <div className="head">Planning & Strategy</div>
        <div className="head">Core Operations</div>
        <div className="head">Financial Management</div>
        <div className="head">Supply Chain</div>
        <div className="head">ESG</div>
        <div className="head">Enterprise Functions</div>
      </div>
      <div className=" icons-m">
        <a
          href="https://industrygenai.accenture.com/formulation"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={BPLAM}
            alt="primary header"
            onClick={props.closeSideBar}
          />
          <p className="landing-text">PRISE</p>
        </a>
        <a
          href="https://industrygenai.accenture.com/ScrmSap"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={scrm}
            alt="primary header"
            onClick={props.closeSideBar}
          />{" "}
          <p className="landing-text">STRIDE</p>
        </a>
        <a
          href="https://industrygenai.accenture.com/lifescience"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={Quaimg}
            alt="primary header"
            onClick={props.closeSideBar}
          />{" "}
          <p className="landing-text">Qualisght</p>
        </a>
        <a
          href="https://industrygenai.accenture.com/fieldservice"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={Optiimg}
            alt="primary header"
            onClick={props.closeSideBar}
          />{" "}
          <p className="landing-text">Optimus</p>
        </a>
      </div>
      <div className=" icons-m">
        <a
          href="https://industrygenai.accenture.com/ewm"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={retail}
            alt="primary header"
            onClick={props.closeSideBar}
          />
          <p className="landing-text">Warehouse Co-Pilot</p>
        </a>
        <a
          href="https://baton-react-app-uitest.cfapps.eu10-004.hana.ondemand.com/baton" target="_blank"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={BATON}
            alt="primary header"
            onClick={props.closeSideBar}
          />
          <p className="landing-text">BATON</p>
        </a>
        <a
          href="https://foresight-react-app-uitest.cfapps.eu10-004.hana.ondemand.com/foresight" target="_blank"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={FORESIGHT}
            alt="primary header"
            onClick={props.closeSideBar}
          />
          <p className="landing-text">FORESIGHT</p>
        </a>
        <a
          href="https://ls_reg_fe.cfapps.eu10-004.hana.ondemand.com/lsregulatoryui" target="_blank"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={LSReg}
            alt="primary header"
            onClick={props.closeSideBar}
          />
          <p className="landing-text">LS Regulatory Compliance</p>
        </a>

      </div>
      <div className=" icons-m">
        <a
          href="https://mkt-content-assistant-react-app-uitest.cfapps.eu10-004.hana.ondemand.com/" target="_blank"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={Marketing}
            alt="primary header"
            onClick={props.closeSideBar}
          />
          <p className="landing-text">Marketing</p>
        </a>
        <a
          href="https://stride-td-og-react-app-uitest.cfapps.eu10-004.hana.ondemand.com/scrm" target="_blank"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={StrideTDOG}
            alt="primary header"
            onClick={props.closeSideBar}
          />
          <p className="landing-text">STRIDE TD OG</p>
        </a>
        <a
          href="https://scope-react-app-uitest.cfapps.eu10-004.hana.ondemand.com/Customerdata" target="_blank"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={SCOPE}
            alt="primary header"
            onClick={props.closeSideBar}
          />
          <p className="landing-text">SCOPE</p>
        </a>
        <a
          href="https://supplyrisk-ui.cfapps.eu10-004.hana.ondemand.com/SuppliRisk" target="_blank"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={SupplierRiskEvaluation}
            alt="primary header"
            onClick={props.closeSideBar}
          />
          <p className="landing-text">Supplier Risk Evaluation</p>
        </a>
      </div>

      {/* <div className="icons-m">
        <a
          href="https://scope-react-app-uitest.cfapps.eu10-004.hana.ondemand.com/Customerdata" target="_blank"
          className="icon-container1-m"
        >
          <img
            className="img-class-m2"
            src={SCOPE}
            alt="primary header"
            onClick={props.closeSideBar}
          />
          <p className="landing-text">Royalty Enquiry</p>
        </a>
      </div> */}
    </div >
  );
};

export default App;
